import { render, staticRenderFns } from "./SmartphoneForm.vue?vue&type=template&id=fa697fae&"
import script from "./SmartphoneForm.vue?vue&type=script&lang=js&"
export * from "./SmartphoneForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports